import { Link } from '@trashlab/sitesapp/src/organizations/redebins/components/shared/link';

export const JunkRemovalPromo = () => {
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-[#333333] mb-4 italic">
            Did Someone Say Junk Removal?
          </h2>
          <p className="text-[#333333] mb-8 italic text-lg">
            Is dumpster rental not your preferred choice? You're just a few clicks from getting our Junk Removal team directly to you.
          </p>

          <div className="bg-gray-50 rounded-lg p-8 mb-6">
            <h3 className="text-xl font-bold text-[#333333] mb-2">
              Call Or Text Us Today!
            </h3>
            <a
              href="tel:9529312577"
              className="text-3xl font-bold text-[#E31837] hover:underline block mb-6"
            >
              952-931-2577
            </a>
            <Link
              href="/junk-removal"
              className="inline-block bg-[#E31837] text-white px-8 py-3 rounded-md font-semibold hover:bg-[#C1152E] transition-colors"
            >
              Click Here For More Info About Junk Removal
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

